import { useCallback, useId, useMemo } from 'react';
import { toast } from 'react-toastify';

import { useFetchWerklijnenOpId } from '@/components/search/hooks/useFetchWerklijnenOpId';
import useClientState from '@/state/useClientState';
import { retry } from '@/utils/retry';

const useWerklijnenSubscription_v2 = () => {
  const { fetchEnkeleWerklijnOpId } = useFetchWerklijnenOpId();

  const generatedSubId = useId();
  const stateSubId = useClientState((state) => Object.keys(state.werklijnenSubs)?.[0]);
  const subId = useMemo(() => stateSubId ?? generatedSubId, [stateSubId, generatedSubId]);
  const voegWerklijnToe = useClientState((state) => state.voegWerklijnToe);

  const addWerklijnById = useCallback(
    async (werklijnId: string) => {
      try {
        const werklijn = await retry(fetchEnkeleWerklijnOpId, 25, werklijnId);
        voegWerklijnToe(subId, werklijn);
      } catch (error) {
        console.log(error);
        toast.error('Toevoegen van nieuwe werklijn is niet gelukt');
      }
    },
    [subId],
  );
  return {
    subId,
    addWerklijnById,
  };
};
export default useWerklijnenSubscription_v2;
